import type { TemperatureEntity } from './entity/temperatureEntity';
import type { TemperatureIRepository } from './entity/temperatureIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 体温ドメインサービス
 */
export class TemperatureDomainService extends DomainServiceBase {
  private temperatureRepository!: TemperatureIRepository;

  /**
   * Injection
   * @param temperatureRepository temperatureRepository
   */
  public inject(
    temperatureRepository: TemperatureIRepository,
  ) {
    this.temperatureRepository = temperatureRepository;
  }

  /**
   * 体温リスト取得
   * @param token トークン
   * @returns リスト
   */
  async getTemperatureList(token: string | null) {
    const result = await this.temperatureRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: TemperatureEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** アイテムリスト */
      items,
    };
  }

  /**
   * 指定日の体温リスト取得
   * @param date 日付
   * @returns リスト
   */
  async getTemperatureListWithDate(date: string) {
    const result = await this.temperatureRepository.getAllListWithKey(date);
    const items = result.map((v: TemperatureEntity) => v.toJson());
    return items;
  }

  /**
   * 体温作成
   * @param entity 入力
   * @returns 結果
   */
  async createTemperature(
    entity: TemperatureEntity,
  ) {
    const result = await this.temperatureRepository.create(entity);
    return result;
  }

  /**
   * 体温更新
   * @param entity 入力
   * @returns 結果
   */
  async updateTemperature(
    entity: TemperatureEntity,
  ) {
    const result = await this.temperatureRepository.update(entity);
    return result;
  }

  /**
   * 体温削除
   * @param entity 入力
   * @returns 結果
   */
  async deleteTemperature(
    entity: TemperatureEntity,
  ) {
    const result = await this.temperatureRepository.delete(entity);
    return result;
  }
}
